import BasicSelect from 'further-ui/components/BasicSelect';
import { FC } from 'react';

type VehicleSelectorProps = {
  selectedVehicle: {
    id: string;
    vehicleName: string;
  };
};

const VehicleSelector: FC<VehicleSelectorProps> = ({ selectedVehicle }) => (
  <BasicSelect
    value={selectedVehicle.id}
    onChange={() => undefined}
    fullWidth
    options={[
      { value: selectedVehicle.id, label: selectedVehicle.vehicleName },
    ]}
    placeholder="Select vehicle"
    disabled
  />
);

export default VehicleSelector;
